/* Florema · Header behaviors
   - Mega-menu dropdown on hover (desktop) / click (mobile)
   - Mobile drawer toggle
   - Cart count update from /cart.js
*/

(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var header = document.querySelector('[data-florema-header]');
    if (!header) return;

    var navItems = header.querySelectorAll('.florema-hdr__nav-item.has-children');
    var mobileToggle = header.querySelector('[data-florema-menu-toggle]');
    var mobileMenu = header.querySelector('[data-florema-mobile-menu]');
    var mobileCloses = header.querySelectorAll('[data-florema-menu-close]');

    // ── Desktop: hover + focus para dropdowns ──
    navItems.forEach(function (item) {
      var link = item.querySelector('.florema-hdr__nav-link');
      var dropdown = item.querySelector('.florema-hdr__dropdown');
      var openTimer = null;
      var closeTimer = null;

      function open() {
        clearTimeout(closeTimer);
        item.classList.add('is-open');
      }
      function close() {
        clearTimeout(openTimer);
        item.classList.remove('is-open');
      }

      item.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        openTimer = setTimeout(open, 80);
      });
      item.addEventListener('mouseleave', function () {
        clearTimeout(openTimer);
        closeTimer = setTimeout(close, 200);
      });

      // Keyboard: focus opens, blur closes
      link.addEventListener('focus', open);
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) close();
      });
    });

    // Close any open dropdown on Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        navItems.forEach(function (item) { item.classList.remove('is-open'); });
        if (mobileMenu) closeMobile();
      }
    });

    // ── Mobile drawer ──
    function openMobile() {
      if (!mobileMenu) return;
      mobileMenu.classList.add('is-open');
      mobileMenu.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'true');
    }
    function closeMobile() {
      if (!mobileMenu) return;
      mobileMenu.classList.remove('is-open');
      mobileMenu.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'false');
    }

    if (mobileToggle) {
      mobileToggle.addEventListener('click', function () {
        if (mobileMenu.classList.contains('is-open')) closeMobile();
        else openMobile();
      });
    }
    mobileCloses.forEach(function (el) {
      el.addEventListener('click', closeMobile);
    });

    // ── Cart count update ──
    function refreshCart() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var counters = document.querySelectorAll('[data-cart-count]');
          counters.forEach(function (c) {
            c.textContent = cart.item_count;
            if (cart.item_count > 0) c.removeAttribute('hidden');
            else c.setAttribute('hidden', '');
          });
        }).catch(function () {});
    }

    // Refresh cart on load + after add events
    refreshCart();
    document.addEventListener('cart:updated', refreshCart);
    window.addEventListener('focus', refreshCart);

    // ── Sticky scroll shadow ──
    function updateScrolled() {
      if (window.scrollY > 4) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
    }
    window.addEventListener('scroll', updateScrolled, { passive: true });
    updateScrolled();

    // ── Reservar espacio en el parent del header fixed ──
    // El header está position:fixed → su parent en el flow colapsa a 0px.
    // Necesitamos setear min-height al parent (shopify-section) para que
    // el contenido siguiente NO quede detrás del header.
    function adjustHeaderSpace() {
      var parent = header.parentElement;
      if (!parent) return;
      var h = header.offsetHeight;
      parent.style.minHeight = h + 'px';
    }
    adjustHeaderSpace();
    window.addEventListener('resize', adjustHeaderSpace, { passive: true });
    // Re-adjust if announcement bar or content changes
    if ('ResizeObserver' in window) {
      new ResizeObserver(adjustHeaderSpace).observe(header);
    }
  });
})();
